<template>
	<div class="extenTecord">
		<div class="search mb-24">
			<search @onSubmit="onSubmit" :platformId="platformId"></search>
		</div>
		<div class="multi-table">
			<multi-table
				ref="multiTable"
				:selectionChange="selectionChange"
				:columns="filterColumns"
				@gePartnerList="gePartnerList"
				:list="list"
				:options="options"
				:total="total"
			>
				<empty :isSearch="isSearch" ref="empty" slot="empty"></empty>
			</multi-table>
		</div>
		<!-- <join ref="join"></join> -->
		<!-- 批量申样 -->
		<apply-sample-drawer ref="applySampleDrawer" :platformId="platformId" @refreshList="getPromotionShopList" />

		<!--无样开播-->
		<sample-free-broadcast-drawer ref="sampleFreeBroadcastDrawer" :platformId="platformId" @refreshList="getPromotionShopList" />
	</div>
</template>
<script>
import search from '../components/search.vue';
// import join from '@/views/common/dialog/join.vue';
import getColums from './columns';
import { promotionShopList } from '@/api/extenTecord';
import * as types from '@/store/mutation-types';
import { mapState, mapGetters } from 'vuex';
import empty from '@/views/common/empty/index.vue';
import applySampleDrawer from '@/components/business/applySampleDrawer';
export default {
	name: 'extenTecord',
	components: {
		search,
		// join,
		empty,
		applySampleDrawer,
		sampleFreeBroadcastDrawer: () => import('@/components/business/sampleFreeBroadcastDrawer'),
	},
	data() {
		return {
			list: [],
			options: {
				selectable: true,
				border: false,
			},
			total: '0',
			selectionShopArr: [],
			share_id: '',
			params: {
				page_index: 1,
				page_size: 10,
			},
			platformId: '',
			share_type: '',
			isSearch: false,
		};
	},
	computed: {
		...mapState(['vuex_shareId', 'vuex_userInfo']),
		...mapGetters(['isDrPartnerDataView']),
		rate_status() {
			return this.vuex_userInfo?.rate_status;
		},
		filterColumns() {
			let newArr = getColums(this).filter(val => val.isShow);
			return newArr;
		},
	},
	created() {
		let share_id = this.$route.query.share_id;
		this.share_id = share_id ? share_id : this.vuex_shareId;
		this.share_type = +this.$route.query.share_type;
		this.platformId = +this.$route.query.platformId || 1;
		this.$store.commit(types.SHARE_ID, this.share_id);
		this.getPromotionShopList();
	},
	methods: {
		//商品列表
		async getPromotionShopList(isSearch) {
			this.isSearch = Boolean(isSearch);
			this.params.share_id = this.share_id;
			const { code, data } = await promotionShopList(this.params);
			if (code == 0) {
				this.list = data.list.map(item => {
					return {
						...item,
						operations: this.getButtons(item),
					};
				});
				this.total = data.page.item_total + '';
			}
		},
		//操作按钮
		getButtons({ other_status }) {
			const copyLink = {
				type: 'copyLink',
				isShow: true,
			};
			const noSampleBroad = {
				label: '无样开播',
				type: 'text',
				isShow: true || this.$auth.hasPermi('system:goods:unsample-broadcasting'),
				classtype: 2,
				click: row => {
					this.$refs.sampleFreeBroadcastDrawer.show([row], 'fast');
				},
			};
			const fastApply = {
				label: '快速申样',
				type: 'text',
				classtype: 2,
				isShow: +other_status === 1 && this.share_type === 1 && this.$auth.hasPermi('system:goods:sampleRequest'),
				click: row => this.$refs.applySampleDrawer.show([row], 'fast', row.product_type === '4'),
			};
			let viewDetail = {
				label: '查看详情',
				type: 'text',
				classtype: 2,
				isShow: this.$auth.hasPermi('system:extenTecord-shopDetails-query'),
				click: ({ product_id, third_product_id, platform_id }) => {
					let handLink = this.$router.resolve({
						path: '/shopManage/extenTecord/details/shopDetails',
						query: { productId: product_id, thirdProductId: third_product_id, platformId: platform_id },
					});
					window.open(handLink.href, '_blank');
				},
			};
			return [copyLink, fastApply, viewDetail, noSampleBroad].filter(item => item.isShow);
		},
		//选择商品
		selectionChange(val) {
			this.selectionShopArr = val;
		},
		//选中值
		checkeFun() {
			this.$Bus.$emit('selection');
		},
		onSubmit(val) {
			this.params = val;
			this.params.page_index = 1;
			this.params.page_size = 10;
			this.$refs.multiTable.resetPage();
			this.getPromotionShopList(1);
		},
		gePartnerList(val) {
			this.params.page_index = val.page_index;
			this.params.page_size = val.page_size;
			this.getPromotionShopList();
		},
	},
};
</script>
<style scss="less" scoped>
.shop-mount {
	padding: 10px;
	border: 6px;
	display: flex;
	justify-content: space-around;
	background-color: #f8f8f8;
}

.shops {
	display: flex;
}

.tab-btn {
	display: flex;
	padding: 20px 0;
	align-items: center;
}
</style>
